/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CollaboType from './CollaboType';
import NftBoxGrade from './NftBoxGrade';
import NftBoxType from './NftBoxType';
import NftGrade from './NftGrade';
import NftSeal from './NftSeal';
import NftType from './NftType';

/**
 * The NftGeneratePublicData model module.
 * @module model/NftGeneratePublicData
 * @version 1.0
 */
class NftGeneratePublicData {
    /**
     * Constructs a new <code>NftGeneratePublicData</code>.
     * @alias module:model/NftGeneratePublicData
     */
    constructor() { 
        
        NftGeneratePublicData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratePublicData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratePublicData} obj Optional instance to populate.
     * @return {module:model/NftGeneratePublicData} The populated <code>NftGeneratePublicData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratePublicData();

            if (data.hasOwnProperty('generateNo')) {
                obj['generateNo'] = ApiClient.convertToType(data['generateNo'], 'Number');
            }
            if (data.hasOwnProperty('itemNo')) {
                obj['itemNo'] = ApiClient.convertToType(data['itemNo'], 'Number');
            }
            if (data.hasOwnProperty('isReveal')) {
                obj['isReveal'] = ApiClient.convertToType(data['isReveal'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('nftBoxGrade')) {
                obj['nftBoxGrade'] = NftBoxGrade.constructFromObject(data['nftBoxGrade']);
            }
            if (data.hasOwnProperty('nftBoxType')) {
                obj['nftBoxType'] = NftBoxType.constructFromObject(data['nftBoxType']);
            }
            if (data.hasOwnProperty('boxBlessed')) {
                obj['boxBlessed'] = ApiClient.convertToType(data['boxBlessed'], 'Boolean');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = NftType.constructFromObject(data['nftType']);
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = NftGrade.constructFromObject(data['nftGrade']);
            }
            if (data.hasOwnProperty('collaboType')) {
                obj['collaboType'] = CollaboType.constructFromObject(data['collaboType']);
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = NftSeal.constructFromObject(data['nftSeal']);
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratePublicData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratePublicData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} generateNo
 */
NftGeneratePublicData.prototype['generateNo'] = undefined;

/**
 * @member {Number} itemNo
 */
NftGeneratePublicData.prototype['itemNo'] = undefined;

/**
 * @member {Boolean} isReveal
 */
NftGeneratePublicData.prototype['isReveal'] = undefined;

/**
 * @member {Date} revealableAt
 */
NftGeneratePublicData.prototype['revealableAt'] = undefined;

/**
 * @member {module:model/NftBoxGrade} nftBoxGrade
 */
NftGeneratePublicData.prototype['nftBoxGrade'] = undefined;

/**
 * @member {module:model/NftBoxType} nftBoxType
 */
NftGeneratePublicData.prototype['nftBoxType'] = undefined;

/**
 * @member {Boolean} boxBlessed
 */
NftGeneratePublicData.prototype['boxBlessed'] = undefined;

/**
 * @member {module:model/NftType} nftType
 */
NftGeneratePublicData.prototype['nftType'] = undefined;

/**
 * @member {module:model/NftGrade} nftGrade
 */
NftGeneratePublicData.prototype['nftGrade'] = undefined;

/**
 * @member {module:model/CollaboType} collaboType
 */
NftGeneratePublicData.prototype['collaboType'] = undefined;

/**
 * @member {module:model/NftSeal} nftSeal
 */
NftGeneratePublicData.prototype['nftSeal'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
NftGeneratePublicData.prototype['plusFlag'] = undefined;

/**
 * @member {Number} count
 */
NftGeneratePublicData.prototype['count'] = undefined;






export default NftGeneratePublicData;

